import { render, staticRenderFns } from "./facebook-reaction.vue?vue&type=template&id=2d91d565&"
import script from "./facebook-reaction.vue?vue&type=script&lang=js&"
export * from "./facebook-reaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports